export default function formatNumber (num, decimals = 0, min_decimals = 1, separatorMode = 'comma') {
  if (num === null || num === undefined) {
    return 0
  }

  if (typeof num === 'string') {
    num = parseFloat(num)
  }

  if (num < 10) {
    decimals = min_decimals
  }

  if (num === 0) {
    return 0
  }

  let numStr = num.toFixed(decimals)
  let fraction = ''

  let decimalSeparator = ','
  let thousandSeparator = '.'

  if (separatorMode === 'period') {
    decimalSeparator = '.'
    thousandSeparator = ','
  }

  if (decimals > 0) {
    fraction = decimalSeparator + numStr.substr(numStr.indexOf('.') + 1)
    numStr = numStr.substr(0, numStr.indexOf('.'))

    if (fraction === ',0' || fraction === '.0') {
      fraction = ''
    }
  }

  return numStr.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousandSeparator) + fraction
}
